import React from "react";
import close from "../img/close.svg";
import deleteIcon from "../img/delete_icon.svg";
import downloadIcon from "../img/download_icon.svg";
import more_icon from "../img/more_icon.svg";
import add_document from "../img/add_document.svg";
import arrow_forward from "../img/arrow_forward.svg";
import JobCardResume from "./JobCardResume";
import useWindowDimensions from "../Account/WindowDimensions";
import ScoreBar from "../Score/ScoreBar";
import { Tooltip } from "react-tooltip";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../store";
import { User, UserScore, UserType } from "../Profile";
import { useAuthToken } from "../AuthProvider";
import { TemplatesDisplay } from "../Templates/TemplatesDisplay";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/* eslint-disable @typescript-eslint/ban-types */
export interface JobDetails {
  company: string;
  title: string;
  uuid: string;
  updateFunc: () => void;
}
/* eslint-enable @typescript-eslint/ban-types */

export interface JobResumeDetails {
  contents: any;
  name: string;
  uuid: string;
  relevance: [string, number][];
  relevant_skills: string;
  other_skills: string;
  skills: number;
  numerical: number;
  verbage: number;
  wording: number;
  total: number;
  relevance_score: number;
}

interface ExperienceDetails {
  metadata: string;
  id: string;
  bullets: [string, string][];
}

const JobCard: React.FC<JobDetails> = ({
  company,
  title,
  uuid,
  updateFunc,
}) => {
  const { isAuthenticated, token, updateToken } = useAuthToken();
  const [isTemplatesOverlayOpen, setIsTemplatesOverlayOpen] =
    React.useState<boolean>(false);
  const [isOverlayOpen, setIsOverlayOpen] = React.useState(false);
  const [isDetailsOverlayOpen, setIsDetailsOverlayOpen] = React.useState(false);
  const [isResumeOverlayOpen, setIsResumeOverlayOpen] = React.useState(false);
  const [isTailorOverlayOpen, setIsTailorOverlayOpen] = React.useState(false);
  const [isImprovementOverlayOpen, setIsImprovementOverlayOpen] =
    React.useState(false);
  const [selectedResume, setSelectedResume] =
    React.useState<JobResumeDetails>();
  const [resumeDetails, setResumeDetails] = React.useState<JobResumeDetails[]>(
    []
  );
  const [experienceData, setExperienceData] = React.useState<
    ExperienceDetails[]
  >([]);
  const [selectedExperience, setSelectedExperience] =
    React.useState<ExperienceDetails>();
  const [improvements, setImprovements] = React.useState<[string, string][]>(
    []
  );
  const [selectedBullet, setSelectedBullet] = React.useState<
    number | undefined
  >(undefined);
  const [improvementText, setImprovementText] = React.useState<string>("");
  const [resumeCredits, setResumeCredits] = React.useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state: AppState) => state.user); // get the current user object from the Redux store

  const [isHovered, setIsHovered] = React.useState(false);
  const [skills, setSkills] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");

  const { height, width } = useWindowDimensions();

  const updateUserResume = (uuid: string) => {
    const updatedUser: User = {
      ...userData, // create a new object with all existing properties of the user object
      resume_uuid: uuid,
    };
    dispatch({
      type: "UPDATE_STATE",
      payload: updatedUser,
    });
  };

  async function submitImprovements() {
    if (improvements.length === 0 || resumeCredits === 0) {
      return;
    }

    const apiEndpoint =  "/api/tailor";

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const formData = new FormData();

    if (selectedResume != undefined) {
      formData.append("resume_uuid", selectedResume.uuid);
    }

    formData.append("improvements", JSON.stringify(improvements));
    formData.append("preferred_template", userData.preferred_template);

    try {
      setIsTailorOverlayOpen(false);

      // Make a POST request using fetch
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: headers,
      });

      if (response.ok) {
        const responseData = await response.json();

        const uuid = responseData.uuid as string;
        updateUserResume(uuid);
        navigate("/score");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }
  }

  async function deleteJob() {
    const apiEndpoint =  "/api/job?job=" + uuid;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await fetch(apiEndpoint, {
        method: "DELETE",
        headers: headers,
      });

      if (response.status == 201) {
        updateFunc();
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }

    setIsOverlayOpen(false);
  }

  async function getResumes() {
    const apiEndpoint =
       "/api/job_resumes?job=" + uuid;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      // Make a POST request using fetch
      const response = await fetch(apiEndpoint, {
        method: "GET",
        headers: headers,
      });

      if (response.ok) {
        const responseData = await response.json();

        const details: JobResumeDetails[] = await responseData.pdf_details;

        setResumeDetails(details.slice(0, 20));
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }
  }

  async function getResumeExperiences(resume: string) {
    const apiEndpoint =
       "/api/resume_experiences?file=" + resume;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      // Make a POST request using fetch
      const response = await fetch(apiEndpoint, {
        method: "GET",
        headers: headers,
      });

      if (response.ok) {
        const responseData = await response.json();

        const data = responseData.experience_data as ExperienceDetails[];

        setExperienceData(data);
        setResumeCredits(responseData.resume_credits);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }
  }

  async function getJobDetails() {
    const apiEndpoint =  "/api/job?job=" + uuid;

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await fetch(apiEndpoint, {
        method: "GET",
        headers: headers,
      });

      const responseData = await response.json();

      const skills: string = responseData.skills;

      setSkills(skills);
      setDescription(responseData.description);
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }

    setIsOverlayOpen(false);
  }

  async function downloadPDF(filename: string, resume_uuid: string) {
    const apiEndpoint = "/api/download?file=" + resume_uuid;

    const headers = {
      "Content-Disposition": "attachment",
      Authorization: `Bearer ${token}`,
    };

    try {
      await fetch(apiEndpoint, {
        method: "GET",
        headers: headers,
      })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }
  }

  React.useEffect(() => {
    if (isTailorOverlayOpen) {
      setExperienceData([]);
      setSelectedExperience(undefined);
      setImprovementText("");
      setSelectedBullet(undefined);
      setIsResumeOverlayOpen(false);
      setIsImprovementOverlayOpen(false);
      setImprovements([]);
    }
  }, [isTailorOverlayOpen]);

  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  return (
    <div className="flex w-full flex-col items-center">
      {isTemplatesOverlayOpen && (
        <div className="overlay z-10">
          <div className="questionnaire-shadow flex w-4/5 flex-col rounded-md bg-white py-[20px]">
            <button
              className="ml-auto mr-6 mt-4"
              onClick={() => setIsTemplatesOverlayOpen(false)}
            >
              <img className="industry-img scale-20" src={close} />
            </button>
            <div>
              <TemplatesDisplay
                callback={() => {
                  submitImprovements();
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div
        className={`w-full rounded-md p-4 transition-colors duration-300 md:p-6 lg:p-8 ${
          isHovered ? "bg-[#828282]" : "dark-panel"
        }`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="flex flex-row justify-between">
          <h1 className="my-auto font-code text-lg font-bold lg:text-xl xl:text-2xl">
            <span className="text-orange">{company.toUpperCase()}</span>
            <span className="light-text"> - {title.toUpperCase()}</span>
          </h1>
          <div className="flex flex-row gap-x-8">
            <button
              className="light-panel details flex h-12 w-12 items-center justify-center rounded-full"
              onClick={() => {
                getJobDetails();
                setIsDetailsOverlayOpen(true);
              }}
              onMouseEnter={() => setIsHovered(false)}
              onMouseLeave={() => setIsHovered(true)}
            >
              <img className="industry-img" src={more_icon} />
            </button>
            <Tooltip anchorSelect=".details" className="font-code" place="top">
              Details
            </Tooltip>
            <button
              className="light-panel add flex h-12 w-12 items-center justify-center rounded-full"
              onClick={() => {
                getResumes();
                setIsResumeOverlayOpen(true);
              }}
              onMouseEnter={() => setIsHovered(false)}
              onMouseLeave={() => setIsHovered(true)}
            >
              <img className="industry-img" src={add_document} />
            </button>
            <Tooltip anchorSelect=".add" className="font-code" place="top">
              Create a resume tailored to this job
            </Tooltip>
            <button
              className="light-panel delete flex h-12 w-12 items-center justify-center rounded-full"
              onClick={() => setIsOverlayOpen(true)}
              onMouseEnter={() => setIsHovered(false)}
              onMouseLeave={() => setIsHovered(true)}
            >
              <img className="industry-img" src={deleteIcon} />
            </button>
            <Tooltip anchorSelect=".delete" className="font-code" place="top">
              Delete this job
            </Tooltip>
          </div>
        </div>
      </div>

      {isTailorOverlayOpen && (
        <div className="overlay z-2">
          <div
            className={`agreement-content ${
              isImprovementOverlayOpen ? "w-4/5 xl:w-1/2" : "w-4/5"
            } h-4/5 overflow-x-hidden overflow-y-scroll`}
          >
            <button
              className="ml-auto"
              onClick={() => setIsTailorOverlayOpen(false)}
            >
              <img className="industry-img scale-20" src={close} />
            </button>

            <div className="flex flex-row">
              <div className="collapse lg:visible">
                {!isImprovementOverlayOpen && (
                  <JobCardResume
                    data={selectedResume?.contents}
                    width={width / 4}
                  />
                )}
              </div>

              <div className="flex w-full flex-col">
                {!isImprovementOverlayOpen && (
                  <div className="flex w-full flex-col">
                    <h1 className="pb-4 pl-4 font-code italic">
                      Skills added: {improvements.length}
                    </h1>
                    {experienceData.map((exp, index) => {
                      return (
                        <div key={index} className="flex w-full">
                          <button
                            className="mx-4 flex w-full flex-row overflow-x-hidden rounded-md px-4 py-4 hover:bg-[#CCCCC1]"
                            onClick={() => {
                              setSelectedExperience(exp);
                              setIsImprovementOverlayOpen(true);
                            }}
                          >
                            <img className="pr-2" src={arrow_forward}></img>
                            <h1 className="lg:text-nowrap text-ellipsis font-code lg:whitespace-nowrap">
                              Add skill to{" "}
                              <span className="font-bold">{exp.metadata}</span>
                            </h1>
                          </button>
                        </div>
                      );
                    })}
                    <button
                      className={` ${
                        improvements.length === 0 || resumeCredits === 0
                          ? `rounded-lg bg-gray-400 text-white`
                          : "start-button"
                      } mx-auto mt-8 w-1/3 px-4 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl`}
                      onClick={() => {
                        setIsTemplatesOverlayOpen(true);
                        setIsImprovementOverlayOpen(false);
                        setIsTailorOverlayOpen(false);
                      }}
                    >
                      Submit
                    </button>
                    <h1
                      className={`w-full pb-4 pl-4 text-center font-code italic ${
                        resumeCredits == 0 ? "text-red-600" : "text-black"
                      }`}
                    >
                      Resume credits: {resumeCredits}
                    </h1>
                  </div>
                )}
                {isImprovementOverlayOpen && (
                  <div className="w-full overflow-y-scroll">
                    <h1 className="pl-4 font-code italic">
                      Select one bullet point to add to.
                    </h1>
                    {selectedExperience?.bullets.map((bullet, index) => {
                      return (
                        <div key={index} className="flex w-full">
                          <button
                            className={`mx-4 flex w-full flex-row overflow-x-hidden rounded-md px-4 py-4 ${
                              selectedBullet === index
                                ? `bg-[#CCCCC1]`
                                : `bg-white`
                            } hover:bg-[#CCCCC1]`}
                            onClick={() => {
                              setSelectedBullet(index);
                            }}
                          >
                            <img className="pr-2" src={arrow_forward}></img>
                            <h1 className="lg:text-nowrap text-ellipsis font-code lg:whitespace-nowrap">
                              Add skill to{" "}
                              <span className="font-bold">{bullet[1]}</span>
                            </h1>
                          </button>
                        </div>
                      );
                    })}
                    <h1 className="mt-16 font-code italic">
                      Required skills: {selectedResume?.other_skills}
                    </h1>
                    <textarea
                      value={improvementText}
                      onInput={(event: React.FormEvent<HTMLTextAreaElement>) =>
                        setImprovementText(event.currentTarget.value)
                      }
                      rows={4}
                      className="placeholder:text-gray mt-4 max-h-min w-full rounded-md border-2 border-black p-4 text-lg placeholder:font-code placeholder:italic lg:text-xl xl:text-2xl"
                      ref={textareaRef}
                      placeholder="What specific skill did you use and how?"
                    />

                    <div className="mx-auto flex w-1/2 flex-row pt-8">
                      <button
                        className={` ${
                          selectedBullet === undefined
                            ? `rounded-lg bg-gray-400 text-white`
                            : "start-button"
                        } mx-auto w-1/3 px-4 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl`}
                        onClick={() => {
                          if (
                            selectedExperience != undefined &&
                            selectedBullet != undefined
                          ) {
                            const newImprovement =
                              selectedExperience.bullets.at(selectedBullet);

                            if (newImprovement != undefined) {
                              improvements.push([
                                newImprovement[0],
                                improvementText,
                              ]);
                              setImprovements(improvements);
                            }

                            setSelectedBullet(undefined);
                            setImprovementText("");
                            setIsImprovementOverlayOpen(false);
                          }
                        }}
                      >
                        Add
                      </button>
                      <button
                        className="login-button mx-auto w-1/3 px-4 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl"
                        onClick={() => {
                          setSelectedBullet(undefined);
                          setImprovementText("");
                          setIsImprovementOverlayOpen(false);
                        }}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {isResumeOverlayOpen && (
        <div className="overlay">
          <div className="agreement-content h-4/5 w-4/5 xl:w-1/2">
            <button
              className="ml-auto"
              onClick={() => setIsResumeOverlayOpen(false)}
            >
              <img className="industry-img scale-20" src={close} />
            </button>

            <div className="overflow-scroll">
              {resumeDetails.length == 0 && (
                <div>
                  <h2 className="2xl:text-2x mx-auto pr-4 pt-12 text-center font-code lg:text-lg xl:text-xl">
                    No resumes to tailor...
                  </h2>
                  <button
                    className="login-button mx-auto mt-8 block w-2/3 px-6 py-2 font-code font-bold md:py-2 md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
                    onClick={() => {
                      navigate("/start");
                    }}
                  >
                    New Resume
                  </button>
                </div>
              )}

              {resumeDetails.map((details, index) => {
                return (
                  <div key={index} className="flex flex-col">
                    <div className="flex flex-row">
                      {width >= 768 && (
                        <div>
                          <JobCardResume
                            data={details.contents}
                            width={width / 6}
                          />
                        </div>
                      )}

                      <div className="mr-16 flex w-full flex-col pl-4 lg:pl-8">
                        <div className="flex flex-col justify-between md:flex-row">
                          <h1 className="font-code text-base font-bold xl:text-lg 2xl:text-xl">
                            {details.name}
                          </h1>
                          <button
                            onClick={() =>
                              downloadPDF(details.name, details.uuid)
                            }
                            className="flex flex-row"
                          >
                            <h1 className="font-code text-sm italic md:hidden">
                              Download
                            </h1>
                            <img className="pl-2" src={downloadIcon}></img>
                          </button>
                        </div>

                        <button
                          className="mr-auto flex flex-row font-code text-sm italic xl:text-base 2xl:text-lg"
                          onClick={() => {
                            setIsTailorOverlayOpen(true);
                            setIsResumeOverlayOpen(false);
                            getResumeExperiences(details.uuid);
                            setSelectedResume(details);
                          }}
                        >
                          Tailor to Job
                          <img className="pl-2" src={arrow_forward}></img>
                        </button>

                        <h2 className="py-2 font-code text-sm xl:text-base 2xl:text-lg">
                          Skills Score
                        </h2>
                        <ScoreBar
                          progress={(details.skills / details.total) * 100}
                          color="#ff8800"
                        />
                        <h2 className="py-2 font-code text-sm xl:text-base 2xl:text-lg">
                          Numerical Score
                        </h2>
                        <ScoreBar
                          progress={(details.numerical / details.total) * 100}
                          color="#ff8800"
                        />
                        <h2 className="py-2 font-code text-sm xl:text-base 2xl:text-lg">
                          Wording Score
                        </h2>
                        <ScoreBar
                          progress={(details.wording / details.total) * 100}
                          color="#ff8800"
                        />
                        <h2 className="py-2 font-code text-sm xl:text-base 2xl:text-lg">
                          Verbage Score
                        </h2>
                        <ScoreBar
                          progress={(details.verbage / details.total) * 100}
                          color="#ff8800"
                        />
                      </div>
                    </div>

                    <div className="pt-4">
                      <h1 className="font-code text-sm xl:text-base 2xl:text-lg">
                        Relevant to{" "}
                        <span className="font-bold">{title.toUpperCase()}</span>{" "}
                        at{" "}
                        <span className="font-bold">
                          {company.toUpperCase()}:{" "}
                        </span>
                      </h1>
                      <h2>{details.relevant_skills}</h2>
                      <h1 className="pt-2 font-code text-sm xl:text-base 2xl:text-lg">
                        Other skills requested by{" "}
                        <span className="font-bold">{title.toUpperCase()}</span>{" "}
                        at{" "}
                        <span className="font-bold">
                          {company.toUpperCase()}:{" "}
                        </span>
                      </h1>
                      <h2>{details.other_skills}</h2>

                      <div className="flex flex-row">
                        <h1 className="pt-4 font-code text-base xl:text-lg 2xl:text-xl">
                          Relevance:{" "}
                          <span className="font-bold">
                            {details.relevance_score.toPrecision(4)}%
                          </span>
                        </h1>
                      </div>
                      <ScoreBar
                        progress={details.relevance_score}
                        color="#00b8e4"
                      />

                      <hr className="mx-auto my-4 h-1 w-48 rounded border-0 bg-gray-500 md:my-10" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {isOverlayOpen && (
        <div className="overlay">
          <div className="agreement-content md:w-1/2">
            <h2 className="text-center font-code md:text-lg lg:text-xl xl:text-2xl ">
              Are you sure you want to delete{" "}
              <span className="font-bold">
                {company.toUpperCase()} - {title.toUpperCase()}
              </span>
              ? This cannot be undone!
            </h2>

            <div className="flex w-full flex-row pt-4 lg:pt-6">
              <button
                className="start-button mx-auto px-4 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl"
                onClick={() => deleteJob()}
              >
                Yes, I&apos;m sure
              </button>
              <button
                className="login-button mx-auto px-4 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl"
                onClick={() => setIsOverlayOpen(false)}
              >
                Nevermind
              </button>
            </div>
          </div>
        </div>
      )}

      {isDetailsOverlayOpen && (
        <div className="overlay block h-screen overflow-y-scroll">
          <div className="agreement-content w-2/3 lg:w-1/2">
            <h1 className="my-auto font-code text-lg font-bold lg:text-xl xl:text-2xl">
              <span className="text-orange">{company.toUpperCase()}</span>
              <span className="text-black"> - {title.toUpperCase()}</span>
            </h1>

            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ flexDirection: "row-reverse" }}
              >
                <h6 className="pl-4 font-code text-lg">Job Description</h6>
              </AccordionSummary>
              <AccordionDetails>
                <div className="max-h-40 overflow-y-scroll">
                  {description.length > 0 && (
                    <h6 className="pl-4 font-code">{description}</h6>
                  )}
                  {description.length < 1 && (
                    <h6 className="pl-4 font-code">No description found...</h6>
                  )}
                </div>
                <hr className="mx-auto my-4 h-1 w-48 rounded border-0 bg-gray-500" />
              </AccordionDetails>
            </Accordion>

            {skills.length > 0 && (
              <div className="flex w-full flex-col">
                <h2 className="2xl:text-2x mx-auto w-full pr-4 pt-4 text-left font-code lg:text-lg xl:text-xl">
                  KEY SKILLS:
                </h2>
                <h2 className="2xl:text-2x mx-auto w-full pr-4 pt-4 text-left font-code font-bold lg:text-lg xl:text-xl">
                  {skills.toUpperCase()}
                </h2>
              </div>
            )}

            {skills.length == 0 && (
              <h2 className="2xl:text-2x mx-auto pr-4 pt-12 font-code lg:text-lg xl:text-xl">
                No skills or requirements found...
              </h2>
            )}

            <div className="flex w-full flex-row pt-4 lg:pt-6">
              <button
                className="login-button mx-auto px-4 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl"
                onClick={() => setIsDetailsOverlayOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobCard;
